import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { getCookie } from '../../../utils/get-cookie';

export const useAuthToken = () => {
  const [userInfo, setUserInfo] = useState({
    authName: undefined,
    hasTokenExpired: true,
    isAuthLoading: true,
    accessToken: undefined
  });

  useEffect(() => {
    const accessToken = getCookie('CVAccessToken');
    if (accessToken !== undefined && accessToken !== '') {
      try {
        const cvTokenObj = JSON.parse(accessToken);
        const tokenString = cvTokenObj?.access_token?.split('.');
        const userInfo = JSON.parse(atob(tokenString[1]));

        if (userInfo)
          setUserInfo(() => ({
            authName: userInfo?.name,
            hasTokenExpired: !dayjs().isBefore(dayjs.unix(userInfo.exp)),
            id: userInfo?.sub,
            accessToken: cvTokenObj?.access_token
          }));
      } catch (error) {
        console.error('failed to get access token', error);
        return null;
      }
    }

    setUserInfo((data) => ({
      ...data,
      isAuthLoading: false
    }));
  }, []);

  return userInfo;
};
